import type { FC, PropsWithChildren, ReactElement } from 'react';

import { MultiContextProvider } from '@luna/context';

import { createRouteRootConfigContext } from './feature-routing/routeConfigContext';

interface Props {
    router: FC<PropsWithChildren & { basename?: string }>;
    basename?: string;
    children: ReactElement;
}

const providers = [createRouteRootConfigContext(undefined)];

/** HashRouter will only be used in React features that are still called from backbone controllers.
 * This wrapper will ensure a leading slash in routes. */
export const GenericLunaRouter: FC<Props> = ({ children, router: Router, basename }) => {
    return (
        <Router basename={basename}>
            <MultiContextProvider providers={providers}>{children}</MultiContextProvider>
        </Router>
    );
};
